<template>
  <div>
    <Header />
    <div class="container">
      <div class="text-center">
        <h2 class="current-pts">{{number_with_commas(cart.current_reward_points)}} Points</h2>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-3" v-for="(reward_item,index) in rewards_groups" :key="index">
          <div class="reward_block">
            <img
              :src='reward_item.photourl'
            />
            <h4>{{reward_item.productname}}</h4>

<!--            We should show all points, even if they have not enough, so they know how to save to it.-->
<!--            <template v-if="reward_item.points_group === 0">-->
<!--              <div class="reward_point">Few points</div>-->
<!--            </template>-->
<!--            <template v-else>-->
              <div class="reward_point">{{number_with_commas(reward_item.points)}} points</div>
<!--            </template>-->

            <button class="reward_btn" v-on:click="open_reward_product_detail_page(reward_item.sku)">Claim</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Header from "../components/header";

import {mapGetters} from "vuex";


export default {
  components: {
    Header
  },
  computed: {
    ...mapGetters({
      cart: 'cart/getCart',
      pages_products: 'cart/pages_products',
    })
  },
  data() {
    return {
      rewards_groups: []
    };
  },
  mounted() {
    this.$store.dispatch('cart/loadShoppingCart');
    this.arrange_reward_products()
  },
  methods:{
    open_reward_product_detail_page(sku) {
      this.$router.push({name: "rewards_detail", 'params':{sku: sku} });
    },
    number_with_commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    get_preview_product(product){
      if(Array.isArray(product)){
        return product
      }else{
        return Object.values(product)
      }
    },
    arrange_reward_products(){
      this.get_preview_product(this.pages_products.rewards_groups).forEach(element => {
        element.forEach(item => {
          this.rewards_groups.push(item)
        })
      });
    }
  },
};
</script>

<style scoped>
  .current-pts{
    font-size: 64px;
    margin: 60px 0;
    font-family: 'Inter';
    font-weight: 800;
  }
  .reward_block{
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 28px;
    background-color: #fff;
    padding: 2rem 1rem;
    text-align: center;
    margin-bottom: 3rem;
  }
  .reward_block h4{
    font-size: 24px;
    font-family: 'Inter';
    text-transform: capitalize;
    margin-top: 20px;
    margin-bottom: 0;
  }
  .reward_block img{
    height: 250px;
    object-fit: contain;
  }
  .reward_point{
    color: #9DC16E;
    font-size: 20px;
    font-family: 'Inter';
  }
</style>
